////
/// ============================================================================
/// COMPONENT / Tabs
///
/// @link https://codepen.io/gsarig/pen/ExKJEoM
/// ============================================================================
///
/// @group components
///
/// <ul role="tablist">
///     <li role="tab" aria-selected="true" aria-controls="panel-1" id="tab-1" tabindex="0" class="is-active"><a /></li>
///     <li role="tab" aria-selected="false" aria-controls="panel-2" id="tab-2" tabindex="-1"><a /></li>
///     <li role="tab" aria-selected="false" aria-controls="panel-3" id="tab-3" tabindex="-1"><a /></li>
/// </ul>
/// <div id="panel-1" role="tabpanel" tabindex="0" aria-labelledby="tab-1"> ... </div>
/// <div id="panel-2" role="tabpanel" tabindex="0" aria-labelledby="tab-2" class="is-hidden"> ... </div>
/// <div id="panel-3" role="tabpanel" tabindex="0" aria-labelledby="tab-3" class="is-hidden"> ... </div>
///
/// @link https://www.w3.org/WAI/ARIA/apg/patterns/tabs/examples/tabs-manual/
////

function Tabs(container) {
    this.container = container;

    this.tabs = container.querySelectorAll("[role=tab]");
    this.panels = [];

    this.activeTab = null;
    this.firstTab = null;
    this.lastTab = null;

    this.tabs.forEach(tab => {
        const panel = document.getElementById(tab.getAttribute("aria-controls"));

        if (!panel) {
            console.warn("Tabs: panel not found: ", tab);
        }

        this.panels.push(panel);

        tab.addEventListener("click", this.onClick.bind(this));

        if (!this.firstTab) {
            this.firstTab = tab;
        }

        if (tab.classList.contains("is-active")) {
            this.activeTab = tab;
        }
    });

    if (!this.activeTab) {
        this.activeTab = this.firstTab;
    }

    this.activateTab(this.activeTab);
}

Tabs.prototype.activateTab = function (currentTab) {
    for (let i = 0; i < this.tabs.length; i += 1) {
        const tab = this.tabs[i];

        if (currentTab === tab) {
            tab.setAttribute("aria-selected", "true");
            tab.setAttribute("tabindex", "0");
            tab.classList.add("is-active");

            this.panels[i].classList.remove('is-hidden');

            this.container.dispatchEvent(
                new CustomEvent("activate", {detail: {tab: tab, panel: this.panels[i]}})
            );
        } else {
            tab.setAttribute("aria-selected", "false");
            tab.setAttribute("tabindex", "-1");
            tab.classList.remove("is-active");

            this.panels[i].classList.add('is-hidden');
        }
    }
}

Tabs.prototype.onClick = function (event) {
    this.activateTab(event.currentTarget);
}

export default () => {
    document.querySelectorAll("[role=tablist].js-tabs").forEach(container => new Tabs(container));
};
